import React from "react";
import styles from "./WhatsAppButton.module.css";
// Asegúrate de tener instalado remixicon o usa CDN en el index.html

const WHATSAPP_NUMBER = "573185078721"; // Número de Tecnotics
const MESSAGE = encodeURIComponent(
  "¡Hola! Quiero más información sobre los servicios de Tecnotics."
);
const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${MESSAGE}`;

const WhatsAppButton: React.FC = () => {
  return (
    <a
      href={WHATSAPP_LINK}
      className={styles.whatsappButton}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chatea por WhatsApp"
    >
      <i className={`ri-whatsapp-fill ${styles.icon}`}></i>
      <span className={styles.tooltip}>¡Chatea con nosotros!</span>
    </a>
  );
};

export default WhatsAppButton;
